import { createSlice } from '@reduxjs/toolkit';
import { MOUSE_EVENT_TYPE } from '../../components/FJMainPreview/FJCreationEditPanel/js/FJViewCanvas';
import FJConfig from '../../config/FJConfig';
import FJAppConstant from '../../constants/FJAppConstant';
import FJConstant from '../../constants/FJConstant';
import FJUtil from '../../util/FJUtil';

export const FJSliceBrushEditCommon = createSlice({
    name: 'brushEditCommon',

    initialState: {
        editImage: null,
        originImage: null,

        brushSize: FJUtil.isMobile() ? 24 : 15,
        curBrushType:
            FJConfig.appType === FJAppConstant.OBJECT_ERASER || FJConfig.appType === FJAppConstant.PHOTO_REMOVE_BG
                ? MOUSE_EVENT_TYPE.MASK_DRAW
                : MOUSE_EVENT_TYPE.NONE,

        isMouseMove: false,
        zoom: 1,

        hasBrushUndo: false,
        hasBrushRedo: false,
        disableReset: true,
        disableCompare: true,
        disableFitButton: true,

        isPhotoRemoveBg: false,

        aiMaskActive: true, // 是否启用ai mask
        isShowBrushInCenter: false, //是否再中心点显示光圈

        editImageRect: { width: 0, height: 0, x: 0, y: 0 },
        compareLineScale: 0.3,
        isSlideCompare: false,
        originImageSize: { width: 0, height: 0 },
        editImageSize: { width: 0, height: 0 },

        brushEditStatus: FJConstant.DEFAULT,
        mobileCanDraw: false, // 移动端当前是否可以编辑画面

        editImageLoadStatus: FJConstant.DEFAULT, // 编辑图片加载状态
    },

    reducers: {
        setSliceBrushSize: (state, action) => {
            state.brushSize = action.payload;
        },
        setSliceCurBrushType: (state, action) => {
            state.curBrushType = action.payload;
        },
        setSliceIsMouseMove: (state, action) => {
            state.isMouseMove = action.payload;
        },
        setSliceZoom: (state, action) => {
            state.zoom = action.payload;
        },
        setSliceHasBrushUndo: (state, action) => {
            state.hasBrushUndo = action.payload;
        },
        setSliceHasBrushRedo: (state, action) => {
            state.hasBrushRedo = action.payload;
        },
        setSliceDisableReset: (state, action) => {
            state.disableReset = action.payload;
        },
        setSliceDisableCompare: (state, action) => {
            state.disableCompare = action.payload;
        },
        setSliceEditImage: (state, action) => {
            state.editImage = action.payload;
        },
        setSliceOriginImage: (state, action) => {
            state.originImage = action.payload;
        },
        setSliceIsShowBrushInCenter: (state, action) => {
            state.isShowBrushInCenter = action.payload;
        },
        setSliceDisableFitButton: (state, action) => {
            state.disableFitButton = action.payload;
        },
        setSliceEditImageRect: (state, action) => {
            state.editImageRect = action.payload;
        },
        setSliceCompareLineScale: (state, action) => {
            state.compareLineScale = action.payload;
        },
        setSliceIsSlideCompare: (state, action) => {
            state.isSlideCompare = action.payload;
        },
        setSliceOriginImageSize: (state, action) => {
            state.originImageSize = action.payload;
        },
        setSliceEditImageSize: (state, action) => {
            state.editImageSize = action.payload;
        },
        setSliceAiMaskActive: (state, action) => {
            state.aiMaskActive = action.payload;
        },
        setSliceIsPhotoRemoveBg: (state, action) => {
            state.isPhotoRemoveBg = action.payload;
        },
        setSliceBrushEditStatus: (state, action) => {
            state.brushEditStatus = action.payload;
        },
        setSliceMobileCanDraw: (state, action) => {
            state.mobileCanDraw = action.payload;
        },
        setSliceEditImageLoadStatus: (state, action) => {
            state.editImageLoadStatus = action.payload;
        },
    },
});

export const {
    setSliceBrushSize,
    setSliceCurBrushType,
    setSliceIsMouseMove,
    setSliceZoom,
    setSliceHasBrushUndo,
    setSliceHasBrushRedo,
    setSliceDisableReset,
    setSliceDisableCompare,
    setSliceEditImage,
    setSliceOriginImage,
    setSliceIsShowBrushInCenter,
    setSliceDisableFitButton,
    setSliceEditImageRect,
    setSliceCompareLineScale,
    setSliceIsSlideCompare,
    setSliceOriginImageSize,
    setSliceEditImageSize,
    setSliceAiMaskActive,
    setSliceIsPhotoRemoveBg,
    setSliceBrushEditStatus,
    setSliceMobileCanDraw,
    setSliceEditImageLoadStatus,
} = FJSliceBrushEditCommon.actions;

export default FJSliceBrushEditCommon.reducer;
